/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTaskStatusDto,
  DeletedResponseDto,
  ReorderTaskStatusesDto,
  TaskStatusDto,
  TaskStatusesControllerDeleteStatusV1Params,
  UpdateTaskStatusDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTaskStatusesControllerListStatusesV1Url = () => {




  return `/v1/task-statuses`
}

/**
 * @summary The workflow, in column order
 */
export const taskStatusesControllerListStatusesV1 = async ( options?: RequestInit): Promise<TaskStatusDto[]> => {

  return apiRequest<TaskStatusDto[]>(getTaskStatusesControllerListStatusesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTaskStatusesControllerListStatusesV1QueryKey = () => {
    return [
    `/v1/task-statuses`
    ] as const;
    }


export const getTaskStatusesControllerListStatusesV1QueryOptions = <TData = Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskStatusesControllerListStatusesV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>> = ({ signal }) => taskStatusesControllerListStatusesV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskStatusesControllerListStatusesV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>>
export type TaskStatusesControllerListStatusesV1QueryError = unknown


export function useTaskStatusesControllerListStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerListStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerListStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The workflow, in column order
 */

export function useTaskStatusesControllerListStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerListStatusesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskStatusesControllerListStatusesV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskStatusesControllerCreateStatusV1Url = () => {




  return `/v1/task-statuses`
}

/**
 * @summary Add a status (owner only)
 */
export const taskStatusesControllerCreateStatusV1 = async (createTaskStatusDto: CreateTaskStatusDto, options?: RequestInit): Promise<TaskStatusDto> => {

  return apiRequest<TaskStatusDto>(getTaskStatusesControllerCreateStatusV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskStatusDto)
  }
);}





export const getTaskStatusesControllerCreateStatusV1QueryKey = (createTaskStatusDto?: CreateTaskStatusDto,) => {
    return [
    'POST', `/v1/task-statuses`, createTaskStatusDto
    ] as const;
    }


export const getTaskStatusesControllerCreateStatusV1QueryOptions = <TData = Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError = unknown>(createTaskStatusDto: CreateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskStatusesControllerCreateStatusV1QueryKey(createTaskStatusDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>> = ({ signal }) => taskStatusesControllerCreateStatusV1(createTaskStatusDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskStatusesControllerCreateStatusV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>>
export type TaskStatusesControllerCreateStatusV1QueryError = unknown


export function useTaskStatusesControllerCreateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError = unknown>(
 createTaskStatusDto: CreateTaskStatusDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerCreateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError = unknown>(
 createTaskStatusDto: CreateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerCreateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError = unknown>(
 createTaskStatusDto: CreateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a status (owner only)
 */

export function useTaskStatusesControllerCreateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError = unknown>(
 createTaskStatusDto: CreateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerCreateStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskStatusesControllerCreateStatusV1QueryOptions(createTaskStatusDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskStatusesControllerReorderStatusesV1Url = () => {




  return `/v1/task-statuses/order`
}

/**
 * @summary Reorder the columns (owner only)
 */
export const taskStatusesControllerReorderStatusesV1 = async (reorderTaskStatusesDto: ReorderTaskStatusesDto, options?: RequestInit): Promise<TaskStatusDto[]> => {

  return apiRequest<TaskStatusDto[]>(getTaskStatusesControllerReorderStatusesV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderTaskStatusesDto)
  }
);}





export const getTaskStatusesControllerReorderStatusesV1QueryKey = (reorderTaskStatusesDto?: ReorderTaskStatusesDto,) => {
    return [
    'PUT', `/v1/task-statuses/order`, reorderTaskStatusesDto
    ] as const;
    }


export const getTaskStatusesControllerReorderStatusesV1QueryOptions = <TData = Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError = unknown>(reorderTaskStatusesDto: ReorderTaskStatusesDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskStatusesControllerReorderStatusesV1QueryKey(reorderTaskStatusesDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>> = ({ signal }) => taskStatusesControllerReorderStatusesV1(reorderTaskStatusesDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskStatusesControllerReorderStatusesV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>>
export type TaskStatusesControllerReorderStatusesV1QueryError = unknown


export function useTaskStatusesControllerReorderStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError = unknown>(
 reorderTaskStatusesDto: ReorderTaskStatusesDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerReorderStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError = unknown>(
 reorderTaskStatusesDto: ReorderTaskStatusesDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerReorderStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError = unknown>(
 reorderTaskStatusesDto: ReorderTaskStatusesDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reorder the columns (owner only)
 */

export function useTaskStatusesControllerReorderStatusesV1<TData = Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError = unknown>(
 reorderTaskStatusesDto: ReorderTaskStatusesDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerReorderStatusesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskStatusesControllerReorderStatusesV1QueryOptions(reorderTaskStatusesDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskStatusesControllerUpdateStatusV1Url = (id: string,) => {




  return `/v1/task-statuses/${id}`
}

/**
 * @summary Rename, recolor, recategorise or make default (owner only)
 */
export const taskStatusesControllerUpdateStatusV1 = async (id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options?: RequestInit): Promise<TaskStatusDto> => {

  return apiRequest<TaskStatusDto>(getTaskStatusesControllerUpdateStatusV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskStatusDto)
  }
);}





export const getTaskStatusesControllerUpdateStatusV1QueryKey = (id: string,
    updateTaskStatusDto?: UpdateTaskStatusDto,) => {
    return [
    'PATCH', `/v1/task-statuses/${id}`, updateTaskStatusDto
    ] as const;
    }


export const getTaskStatusesControllerUpdateStatusV1QueryOptions = <TData = Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError = unknown>(id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskStatusesControllerUpdateStatusV1QueryKey(id,updateTaskStatusDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>> = ({ signal }) => taskStatusesControllerUpdateStatusV1(id,updateTaskStatusDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskStatusesControllerUpdateStatusV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>>
export type TaskStatusesControllerUpdateStatusV1QueryError = unknown


export function useTaskStatusesControllerUpdateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError = unknown>(
 id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerUpdateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError = unknown>(
 id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerUpdateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError = unknown>(
 id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rename, recolor, recategorise or make default (owner only)
 */

export function useTaskStatusesControllerUpdateStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError = unknown>(
 id: string,
    updateTaskStatusDto: UpdateTaskStatusDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerUpdateStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskStatusesControllerUpdateStatusV1QueryOptions(id,updateTaskStatusDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskStatusesControllerDeleteStatusV1Url = (id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/task-statuses/${id}?${stringifiedParams}` : `/v1/task-statuses/${id}`
}

/**
 * 409 when it has tasks and no `moveTo`, or when it is the last unstarted/completed status.
 * @summary Delete a status, moving its tasks (owner only)
 */
export const taskStatusesControllerDeleteStatusV1 = async (id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTaskStatusesControllerDeleteStatusV1Url(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTaskStatusesControllerDeleteStatusV1QueryKey = (id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params,) => {
    return [
    'DELETE', `/v1/task-statuses/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getTaskStatusesControllerDeleteStatusV1QueryOptions = <TData = Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError = unknown>(id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskStatusesControllerDeleteStatusV1QueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>> = ({ signal }) => taskStatusesControllerDeleteStatusV1(id,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskStatusesControllerDeleteStatusV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>>
export type TaskStatusesControllerDeleteStatusV1QueryError = unknown


export function useTaskStatusesControllerDeleteStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError = unknown>(
 id: string,
    params: undefined |  TaskStatusesControllerDeleteStatusV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerDeleteStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError = unknown>(
 id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>,
          TError,
          Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskStatusesControllerDeleteStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError = unknown>(
 id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a status, moving its tasks (owner only)
 */

export function useTaskStatusesControllerDeleteStatusV1<TData = Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError = unknown>(
 id: string,
    params?: TaskStatusesControllerDeleteStatusV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskStatusesControllerDeleteStatusV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskStatusesControllerDeleteStatusV1QueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






